import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import { FaPen, FaUserCircle } from 'react-icons/fa';
import { useAppContext } from '../../context/AppContext';
//import workerSrc from 'pdfjs-dist/build/pdf.worker.min.js';


import './PdfUpload.css';


// ...existing code...
//pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/5.3.31/pdf.worker.min.js`;
// ...existing code...

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;
//pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//'pdfjs-dist/build/pdf.worker.min.js',
//import.meta.url
//).toString();




const PdfUpload = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [pdfFiles, setPdfFiles] = useState([]);
  const [pdfPreviews, setPdfPreviews] = useState([]);
  const [details, setDetails] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedDetail, setEditedDetail] = useState('');
  const [currentPages, setCurrentPages] = useState([]);
  const [zoomLevels, setZoomLevels] = useState([]);
  const [numPagesList, setNumPagesList] = useState([]);
  const [profileDropdown, setProfileDropdown] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [completedSteps] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [radioSelection, setRadioSelection] = useState('');
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [projectHistory, setProjectHistory] = useState([]);
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("projectHistory")) || [];
    setProjectHistory(stored);
  }, []);



  const userEmail = 'Eezeelearn@gmail.com';

  useEffect(() => {
    if (location.state) {
      const {
        pdfFiles,
        pdfPreviews,
        details,
        selectedOptions,
        radioSelection,

        stepFlow,
        currentStepIndex,
        fileName,
        userEmail
      } = location.state;



      setPdfFiles(pdfFiles || []);
      setPdfPreviews(pdfPreviews || []);
      setDetails(details || []);
      setSelectedOptions(selectedOptions || []);
      setRadioSelection(radioSelection || '');
      // setStepFlow(stepFlow || []);
      //setCurrentStepIndex(currentStepIndex || 0);
      //setFileName(fileName || 'Uploaded_File.pdf');
      //setUserEmail(userEmail || 'Eezeelearn@gmail.com');
    }
  }, []);

  const checkboxOptions = [
    'Image Extraction',
    'Translation',
    'Transliteration',
    'Audio Generation',
    'Video Generation',
  ];
  const stepRouteMap = {
    'Text Extraction': 'text-extraction',
    'Text Summarization': 'TextSummarization',
    'Image Extraction': 'image',
    'Translation': 'Translation',
    'Transliteration': 'transliteration',
    'Audio Generation': 'Audiogeneration',
    'Video Generation': 'video'
  };

  const handleSignOut = () => {
    navigate(`/signin`);
  };
  const toggleProfileDropdown = () => setProfileDropdown(!profileDropdown);

  const handleCheckboxChange = (option) => {
    setSelectedOptions((prev) =>
      prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option]
    );
  };

  const handleRadioSelection = (value) => {
    setRadioSelection(value);
  };

  const handleSelectAll = () => {
    if (selectedOptions.length === checkboxOptions.length) {
      setSelectedOptions([]);
    } else {
      setSelectedOptions([...checkboxOptions]);
    }
  };

  const buildStepFlow = () => {
    const flow = [];
    if (radioSelection) flow.push(radioSelection);
    return [...flow, ...selectedOptions];
  };

  const stepFlow = buildStepFlow();
  const fileName = details[0]?.fileName || 'Uploaded_File.pdf';

  const handleExtract = async () => {
    if (!radioSelection) {
      alert("Please select 'Text Extraction' or 'Text Summarization'");
      return;
    }

    if (stepFlow.length === 0) {
      alert("Please select at least one processing step.");
      return;
    }

    const nextStep = stepRouteMap[stepFlow[0]];
    saveProjectToHistory(); // ✅ Save to history


    // Optional: perform extraction first if needed immediately
    if (radioSelection === "Text Extraction") {
      navigate(`/${nextStep}`, {
        state: {
          pdfFiles,
          pdfPreviews,
          details,
          stepFlow,
          currentStepIndex: 0,
          currentStep: stepFlow[0],
          fileName,
          userEmail,
          pdfUrl: pdfPreviews[0],
          pdfName: pdfFiles[0]?.name,
          file: pdfFiles[0],// ✅ REQUIRED for backend
          completedSteps: [radioSelection], // ✅ Set the selected step as completed
          selectedOptions
        }
      });
    }

    if (radioSelection === "Text Summarization") {
      navigate(`/${nextStep}`, {
        state: {
          stepFlow,
          currentStepIndex: 0,
          currentStep: stepFlow[0],
          fileName,
          userEmail,
          pdfUrl: pdfPreviews[0],
          pdfName: pdfFiles[0]?.name,
          file: pdfFiles[0],  // ✅ pass file for summarization flow too
          completedSteps: [radioSelection],  // ✅ important
          selectedOptions
        }

      });
    }

    {/*  const nextStep = stepRouteMap[stepFlow[0]];
    navigate(`/${nextStep}`, {
      state: {
        stepFlow,
        currentStepIndex: 0,
        fileName,
        userEmail,
      },
    }); */}
  };

  const handlePrevious = () => {
    navigate(`/signin`);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files).filter(file => file.type === "application/pdf");
    setPdfFiles(files);
    setPdfPreviews(files.map((file) => URL.createObjectURL(file)));

    setDetails(files.map((file) => {
      const name = file.name.replace('.pdf', '');
      const parts = name.split('_');

      let standard = 'Unknown';
      let subject = 'Unknown';
      let medium = 'Unknown';

      const classMatch = name.match(/(?:Class|Std)[-_ ]?(\d+)/i);
      const mediumMatch = name.match(/(?:_)?(Tamil|English|Malayalam|Hindi)[-_ ]?(Medium)?/i);

      if (classMatch) standard = classMatch[1];

      const subjectGuess = parts.find((p, i) =>
        i > 0 &&
        p.toLowerCase() !== 'class' &&
        p.toLowerCase() !== standard.toLowerCase() &&
        !['medium', 'edition', 'www', 'in', 'tntxtbooks'].includes(p.toLowerCase())
      );

      if (subjectGuess) subject = subjectGuess.charAt(0).toUpperCase() + subjectGuess.slice(1);
      if (mediumMatch) medium = mediumMatch[1].charAt(0).toUpperCase() + mediumMatch[1].slice(1).toLowerCase();

      return {
        class: standard,
        subject: subject,
        language: medium,
        fileName: file.name,
      };
    }));

    setCurrentPages(files.map(() => 1));
    setZoomLevels(files.map(() => 300));
    setNumPagesList(files.map(() => 1));
  };

  const handleEditClick = (index, key) => {
    setEditingIndex({ index, key });
    setEditedDetail(details[index][key]);
  };

  const handleEditSave = () => {
    const updated = [...details];
    updated[editingIndex.index][editingIndex.key] = editedDetail;
    setDetails(updated);
    setEditingIndex(null);
  };

  const saveProjectToHistory = () => {
    const currentProject = {
      fileName,
      pdfUrl: pdfPreviews[0],
      pdfName: pdfFiles[0]?.name,
      file: pdfFiles[0],
      completedSteps: [radioSelection],
      selectedOptions,
      stepFlow,
      time: new Date().toISOString(),
    };

    const existing = JSON.parse(localStorage.getItem("projectHistory")) || [];
    const updated = [currentProject, ...existing].slice(0, 3); // keep last 5
    localStorage.setItem("projectHistory", JSON.stringify(updated));
  };


  return (
    <div className="page-container">
      {/* Sidebar */}
      <div className="sidebar">
        <div className="sidebar-profile" onClick={toggleProfileDropdown}>
          <FaUserCircle className="sidebar-profile-icon" />
          <div className="sidebar-profile-name">{userEmail}</div>
          {profileDropdown && (
            <div className="profile-dropdown">
              <div className="dropdown-item">Change Password</div>
              <div className="dropdown-item" onClick={handleSignOut}>Logout</div>
            </div>
          )}
        </div>

        <div className="sidebar-menu">
          <div className="sidebar-item section-title">Recent Projects</div>
          <div className="sidebar-submenu">
            {projectHistory.length === 0 ? (
              <div className="sidebar-subitem">No recent projects</div>
            ) : (
              projectHistory.map((proj, idx) => (
                <div key={idx} className="sidebar-subitem">
                  <strong>{proj.fileName}</strong>
                  <div style={{ fontSize: '12px', color: '#555' }}>
                    {['PDF Upload', ...proj.stepFlow].join(' ➜ ')}
                  </div>
                  <div style={{ fontSize: '11px', color: '#999' }}>
                    {new Date(proj.time).toLocaleString()}
                  </div>
                  <button
                    style={{
                      padding: '4px 8px',
                      fontSize: '12px',
                      backgroundColor: '#225474',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      const stepRouteMap = {
                        'Text Extraction': 'text-extraction',
                        'Text Summarization': 'TextSummarization',
                        'Image Extraction': 'image',
                        'Translation': 'Translation',
                        'Transliteration': 'transliteration',
                        'Audio Generation': 'Audiogeneration',
                        'Video Generation': 'video',
                      };
                      const firstStep = proj.stepFlow[0];
                      const route = stepRouteMap[firstStep];
                      navigate(`/${route}`, {
                        state: {
                          ...proj,
                          currentStep: firstStep,
                          currentStepIndex: 0,
                        }
                      });
                    }}
                  >
                    Resume
                  </button>
                </div>

              ))
            )}
          </div>
          <div className="sidebar-item" onClick={() => setShowHistory(false)}>New Project</div>

          {!showHistory && (
            <div className="sidebar-section">
              <div className="sidebar-item section-title">{fileName}</div>
              <div className="sidebar-submenu">
                <div className="sidebar-subitem completed">PDF Upload</div>
                {stepFlow.map((step, idx) => (
                  <div key={idx} className="sidebar-subitem    ${completedSteps.includes(step) ? 'completed' : ''} 
      ${step === currentStep ? 'current-step' : ''} 
      enabled}">{step}</div>
                ))}
              </div>
            </div>
          )}

          <div className="sidebar-item">Settings</div>
        </div>

        <div className="sidebar-footer">
          <button className="sidebar-logout-btn" onClick={handleSignOut}>Sign out</button>
        </div>
      </div>

      {/* Main Upload Panel */}
      <div className="pdf-container">
        {!showHistory && (
          <div className="upload-section">
            <div className="preview-container">
              {pdfFiles.map((file, i) => {
                console.log("?? Previewing:", file); // LOG OUTSIDE JSX

                return (<div key={i} className="preview-item">
                  <div className="file-name">{file.name}</div>
                  {/* <div className="pdf-controls">
                    <button onClick={() => setZoomLevels(prev => prev.map((z, j) => j === i ? z - 20 : z))}>-</button>
                    <span>Zoom</span>
                    <button onClick={() => setZoomLevels(prev => prev.map((z, j) => j === i ? z + 20 : z))}>+</button>
                    <input
                      type="number"
                      value={currentPages[i] || 1}
                      min={1}
                      max={numPagesList[i] || 1}
                      onChange={(e) => setCurrentPages(prev => prev.map((p, j) => j === i ? Number(e.target.value) : p))}
                      className="page-input"
                    />
                    <span> / {numPagesList[i] || 1}</span>
                  </div> 
                  <Document
                    file={file}
                    onLoadSuccess={({ numPages }) => {
                      console.log("? Loaded pages:", numPages);
                      setNumPagesList(prev => prev.map((n, j) => j === i ? numPages : n));
                    }}
                    onLoadError={(err) => {
                      console.error("? PDF error:", pdfFiles[i], err);
                    }}


                  >
                    <Page pageNumber={currentPages[i] || 1} width={zoomLevels[i] || 500} />
                  </Document> */}
                  <iframe className="pdf-iframe"
                    src={pdfPreviews[i]}
                    title={`PDF Preview ${i}`}


                  ></iframe>



                </div>
                );
              })}
            </div>

            <div className="upload-details-panel">
              <div className="upload-box" onClick={() => document.getElementById('pdfInput').click()}>
                <div className="drag-icon">📤</div>
                <div className="upload-controls">
                  <label className="upload-dropdown">
                    Upload PDF <br />
                    <select onChange={(e) => {
                      if (e.target.value === 'computer') document.getElementById('pdfInput').click();
                      else alert('Drive upload not implemented');
                      e.target.selectedIndex = 0;
                    }}>
                      <option>Choose source</option>
                      <option value="computer">From Computer</option>
                      <option value="drive">From Drive</option>
                    </select>
                  </label>
                </div>
                <input id="pdfInput" type="file" accept="application/pdf" multiple onChange={handleFileChange} className="file-input" />
              </div>

              <div className="details-section">
                {details.map((item, index) => (
                  <div key={index} className="detail-block">
                    {['class', 'subject', 'language'].map((key) => (
                      <div className="detail-row" key={key}>
                        {editingIndex?.index === index && editingIndex.key === key ? (
                          <input
                            value={editedDetail}
                            onChange={(e) => setEditedDetail(e.target.value)}
                            onBlur={handleEditSave}
                            autoFocus
                          />
                        ) : (
                          <>
                            <span>{item[key]}</span>
                            <FaPen className="edit-icon" onClick={() => handleEditClick(index, key)} />
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>

              {/* Radio & Checkbox Section */}
              {pdfFiles.length > 0 && (
                <div className="checkbox-section">
                  <div className="radio-section">
                    <div className="radio-label-text">Choose your Text content type:</div>
                    <div className="radio-group-vertical">
                      <label className="radio-option">
                        <input
                          type="radio"
                          name="textOption"
                          value="Text Extraction"
                          checked={radioSelection === "Text Extraction"}
                          onChange={(e) => handleRadioSelection(e.target.value)}
                        />
                        Text Extraction
                      </label>
                      <label className="radio-option">
                        <input
                          type="radio"
                          name="textOption"
                          value="Text Summarization"
                          checked={radioSelection === "Text Summarization"}
                          onChange={(e) => handleRadioSelection(e.target.value)}
                        />
                        Text Summarization
                      </label>
                    </div>
                  </div>

                  <label className="checkbox-option">
                    <input
                      type="checkbox"
                      checked={selectedOptions.length === checkboxOptions.length}
                      onChange={handleSelectAll}
                    />
                    <span>Select All</span>
                  </label>

                  {checkboxOptions.map((label, index) => (
                    <label className="checkbox-option" key={index}>
                      <input
                        type="checkbox"
                        checked={selectedOptions.includes(label)}
                        onChange={() => handleCheckboxChange(label)}
                      />
                      <span>{label}</span>
                    </label>
                  ))}
                </div>
              )}

              <div className="previous-button">
                <button onClick={handlePrevious}>Previous</button>
              </div>
            </div>

            <div className="extract-button">
              <button disabled={!radioSelection && selectedOptions.length === 0} onClick={handleExtract}>
                Extract
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PdfUpload;
